const IS_REACT_SNAP =
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

const snapJsonCache = new Map();

const normalizePath = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  return raw.startsWith("/") ? raw : `/${raw}`;
};

export { IS_REACT_SNAP };

export async function loadPrerenderJson(path) {
  if (typeof window === "undefined") return null;
  const normalizedPath = normalizePath(path);
  if (!normalizedPath) return null;

  if (!snapJsonCache.has(normalizedPath)) {
    const request = fetch(`${process.env.PUBLIC_URL || ""}${normalizedPath}`, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    })
      .then(async (response) => {
        if (!response.ok) return null;
        try {
          return await response.json();
        } catch (_) {
          return null;
        }
      })
      .catch(() => null);

    snapJsonCache.set(normalizedPath, request);
  }

  return snapJsonCache.get(normalizedPath);
}

export async function loadReactSnapJson(path) {
  if (!IS_REACT_SNAP) return null;
  return loadPrerenderJson(path);
}
